import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import s from './EventPrivacyPolicy.module.scss';

export default function EventPrivacyPolicy() {
  return (
    <SiteLayout helmet={{ title: 'Event Privacy Policy' }}>
      <div className={s.wrapper}>
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-8">
              <h1>Event Privacy Notice</h1>
              <p>
                Informa will use your personal information provided during the
                registration process to manage our events, specifically in the
                following way:
              </p>
              <h2>Manual Badge Scanning</h2>
              <p>
                When attending our in-person events, by allowing your badge to
                be scanned by an exhibitor or sponsor, you are providing the
                exhibitor or sponsor with your personal information and in doing
                so, you agree to the exhibitor or sponsor contacting you in the
                future about their products or services. You understand that you
                can opt-out of this contact at any time by contacting the
                exhibitor or sponsor. Badges cannot be read remotely and must be
                scanned before any details are shared with exhibitors and
                sponsors. You have the right to refuse badge scanning except
                when entering or exiting the event.
              </p>
              <h2>Smart Tag Attendance Monitoring</h2>
              <p>
                We may also use smart tag technology to record and monitor
                attendance at our live sessions, which removes the need for
                manual badge scanning when entering and exiting. We will share
                your personal information with the sponsors of the live
                sessions, and they may contact you with more information about
                their product and services. You may opt-out of receiving the
                smart tag or cease attendance monitoring at any time by
                informing our registration desk or contacting a member of our
                event staff.
              </p>
              <h2>Virtual Events</h2>
              <p>
                When attending our virtual events if you enter or interact with
                a virtual exhibition booth your personal information will be
                shared with the exhibitor to allow them to engage with you both
                during and after the event. If you accept a connection/meeting
                invite, interact with sponsored content (e.g. attend live
                session, download or bookmark companies/content) then your full
                contact details will be shared directly with the sponsor or
                exhibitor, and they may follow-up in line with your indication
                of interest in their products.
              </p>
            </div>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
